import { createSlice } from '@reduxjs/toolkit';
import { LDFlagSet } from 'launchdarkly-node-server-sdk';
import { RootState } from './types';

const initialState: LDFlagSet = {};

export const ldFlagsSlice = createSlice({
  name: 'ldFlags',
  initialState,
  reducers: {
    setLdFlags: (state, action) => {
      Object.assign(state, action.payload);
    },
  },
});

export const { setLdFlags } = ldFlagsSlice.actions;

export const selectLdFlags = (state: RootState) => state.ldFlags;

export default ldFlagsSlice.reducer;
